import React, { useState, useEffect } from "react";

const UnsupportedBrowserMessage = () => {
  const [isBrowserSupported, setIsBrowserSupported] = useState(true);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // Check browser support only on client-side after hydration
    setIsHydrated(true);
    
    if (typeof navigator !== "undefined") {
      // Use manual browser detection instead of browserslist-useragent
      // to avoid "process is not defined" error in browser environment
      const userAgent = navigator.userAgent.toLowerCase();
      
      // Check for supported browsers (desktop & mobile)
      const isChrome = /chrome|crios/.test(userAgent);
      const isFirefox = /firefox|fxios/.test(userAgent);
      const isEdge = /edg/.test(userAgent);
      const isSafari = /safari/.test(userAgent) && !/chrome|crios|fxios|edg|gsa/.test(userAgent);
      // Detect any version of Internet Explorer (IE 7-11)
      const isIE = /trident|msie/.test(userAgent);
      const isIE11 = /trident.*rv:11/.test(userAgent);
      const isSamsungInternet = /samsungbrowser/.test(userAgent);
      const isOpera = /opr\/|opera/.test(userAgent);
      // Google Search App in-app browser (uses "GSA/" in user agent)
      const isGoogleApp = /\bgsa\//.test(userAgent);
      
      // iOS WebView / in-app browsers all use WebKit — treat as supported
      // if OS version is recent enough (iOS 14+)
      const isIOSWebView = /iphone|ipad|ipod/.test(userAgent) && !/safari/.test(userAgent);
      const getIOSVersion = () => {
        const match = userAgent.match(/os (\d+)[_\s]/);
        return match ? parseInt(match[1], 10) : 0;
      };

      // Check for minimum versions
      const getChromeVersion = () => {
        const match = userAgent.match(/(?:chrome|crios)[\/\s](\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };
      
      const getFirefoxVersion = () => {
        const match = userAgent.match(/(?:firefox|fxios)[\/\s](\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };
      
      const getEdgeVersion = () => {
        const match = userAgent.match(/edg[e\/\s](\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };
      
      const getSafariVersion = () => {
        const match = userAgent.match(/version[\/\s](\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };

      const getSamsungVersion = () => {
        const match = userAgent.match(/samsungbrowser[\/\s](\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };

      const getOperaVersion = () => {
        const match = userAgent.match(/opr[\/\s](\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };
      const getGoogleAppVersion = () => {
        const match = userAgent.match(/gsa\/(\d+)/);
        return match ? parseInt(match[1], 10) : 0;
      };      
      // IE < 11 is explicitly unsupported; IE 11 is kept as supported
      const isSupported = 
        !isIE ||
        isIE11 ||
        (isChrome && getChromeVersion() >= 90) ||
        (isFirefox && getFirefoxVersion() >= 88) ||
        (isEdge && getEdgeVersion() >= 90) ||
        (isSafari && getSafariVersion() >= 12) ||
        (isSamsungInternet && getSamsungVersion() >= 12) ||
        (isOpera && getOperaVersion() >= 76) ||
        (isGoogleApp && getGoogleAppVersion() >= 100) ||
        (isIOSWebView && getIOSVersion() >= 12);
      
      setIsBrowserSupported(isSupported);
    }
  }, []);

  // Don't render during SSR or before hydration
  if (!isHydrated || isBrowserSupported) {
    return null;
  }

  return (
    <div style={overlayStyles}>
      <div style={modalStyles}>
        <h2 style={headingStyles}>Browser Not Supported</h2>
        <p style={paragraphStyles}>
          It looks like you're using an outdated browser. To view this site 
          properly, please switch to a more modern browser such as<span> </span> 
          <a href="https://www.google.com/chrome/">Chrome</a>, 
          <a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>, 
          or <a href="https://www.microsoft.com/edge">Edge</a>.
        </p>
      </div>
    </div>
  );
};

// Styles with mobile responsiveness
const overlayStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
  padding: "16px",
  boxSizing: "border-box",
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
};

const modalStyles = {
  background: "#fff",
  padding: "24px 20px",
  borderRadius: "8px",
  maxWidth: "400px",
  width: "100%",
  textAlign: "center",
  boxSizing: "border-box",
  wordWrap: "break-word",
  overflowWrap: "break-word",
};

const headingStyles = {
  fontSize: "clamp(1.1rem, 4vw, 1.5rem)",
  margin: "0 0 12px",
};

const paragraphStyles = {
  fontSize: "clamp(0.9rem, 3.5vw, 1rem)",
  lineHeight: 1.5,
  margin: 0,
};

export default UnsupportedBrowserMessage;
